import config from 'config';
import { http_client } from './api';

const getList = async (page = null, perPage = null, sort = null, orderBy = null, search = null) => {
  return http_client
    .get(
      config.apiUrl +
        'jenjang?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}`
    )
    .then((response) => {
      return response.data;
    });
};
const getListArchive = async (page = null, perPage = null, sort = null, orderBy = null, search = null) => {
  return http_client
    .get(
      config.apiUrl +
        'jenjang/archive?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}`
    )
    .then((response) => {
      return response.data;
    });
};

const create = async (data) => {
  return http_client.post(config.apiUrl + 'jenjang', data).then((response) => {
    return response.data;
  });
};
const read = async (id) => {
  return http_client.get(config.apiUrl + 'jenjang/' + id).then((response) => {
    return response.data;
  });
};
const update = async (id, data) => {
  return http_client.patch(config.apiUrl + 'jenjang/' + id, data).then((response) => {
    return response.data;
  });
};
const del = async (id) => {
  return http_client.delete(config.apiUrl + 'jenjang/' + id).then((response) => {
    return response.data;
  });
};
const changeStatus = async (id, data) => {
  return http_client.post(config.apiUrl + 'jenjang/status/' + id, data).then((response) => {
    return response.data;
  });
};
const JenjangService = {
  getList,
  getListArchive,
  create,
  read,
  update,
  del,
  changeStatus
};

export default JenjangService;
